export default {
	namespaced: true,
	state: {
		providers: false,
		selectedProvider: false
	},
	getters: {
		providers: state => {
			return state.providers;
		},
		selectedProvider: state => {
			return state.selectedProvider ? state.selectedProvider : state.providers[0];
		},
	},
	mutations: {
		updateProviders(state, providers) {
			state.providers = providers;
		},
		setSelectedProvider(state, provider) {
			state.selectedProvider = provider;
		},
	},
	actions: {


	}
}
